import { Grid } from "@material-ui/core";
import { InputOptionMaster, InputTextMaster } from "App/Component/ui";
import { isNull } from "App/utils/helpers";
import { AssesmentPelayananRawatJalan } from "./AssesmentPelayanan";
import { TYPE_INSTANCE1 } from "App/constants";
import {
  PILIH_TUJUAN_KUNJUNGAN,
  TUJUAN_KUNJUNGAN_KONSUL,
  TUJUAN_KUNJUNGAN_PROSEDUR,
} from "./../constants";
import { PilihKodePenunjang } from "../SelectOption/PilihKodePenunjang";
import { PilihFlagProcedure } from "../SelectOption/PilihFlagProcedure";
import { useDokterSEP } from "../hooks";
import useMultipleSelect, {
  validasiMultipleSelect,
} from "hooks/useMultipleSelect";
import { LIST_URL_MASTER } from "utils/masters";
import React from "react";

export const FormHanyaJikaRawatJalan = ({
  formData,
  handleChange,
  type,
  setFormData,
}) => {
  const dokter = useDokterSEP();
  const multipleSelectData = useMultipleSelect([
    {
      url: LIST_URL_MASTER.spesialis.list,
      search: true,
      type_instance: TYPE_INSTANCE1,
      value: "codebridgepolibpjs",
      label: ["name"],
      type_response: "body",
      key: "spesialis",
    },
  ]);

  if (type === "RJ") {
    return (
      <>
        <Grid item sm={3}>
          <InputTextMaster
            name='tgl_rujukan'
            label='TGL RUJUKAN'
            id='tgl_rujukan'
            type='date'
            required={true}
            value={formData.tgl_rujukan}
            onChange={handleChange("tgl_rujukan")}
            placeholder=''
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='ppk_rujukan_name'
            label='PPK RUJUKAN'
            id='ppk_rujukan_name'
            required={true}
            value={formData.ppk_rujukan_name}
            onChange={handleChange("ppk_rujukan_name")}
            placeholder=''
          />
        </Grid>

        <Grid item xs={4}>
          <InputTextMaster
            name='no_rujukan'
            label='NO RUJUKAN'
            id='no_rujukan'
            readOnly={true}
            disabled={true}
            value={formData.no_rujukan}
            onChange={handleChange("no_rujukan")}
            placeholder=''
          />
        </Grid>
        <Grid item sm={4}>
          <InputOptionMaster
            name='kode_dpjp'
            label='DPJP'
            id='kode_dpjp'
            withSearch={true}
            needParse={false}
            value={formData.kode_dpjp}
            labelValue={formData.kode_dpjp_dokter}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  kode_dpjp: null,
                  kode_dpjp_dokter: "Pilih DPJP",
                });
              } else {
                setFormData({
                  ...formData,
                  kode_dpjp: e?.value,
                  kode_dpjp_dokter: e?.label,
                });
              }
            }}
            data={dokter}
          />
        </Grid>
        <Grid item sm={4}>
          <InputOptionMaster
            name='kode_poliklinik'
            label='POLIKLINIK'
            id='kode_poliklinik'
            withSearch={true}
            data={validasiMultipleSelect(multipleSelectData, 0)}
            value={formData.kode_poliklinik}
            labelValue={formData.nama_poliklinik}
            disabled={formData?.katarak??false}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  kode_poliklinik: null,
                  nama_poliklinik: "Pilih Poliklinik",
                });
              } else {
                setFormData({
                  ...formData,
                  kode_poliklinik: e.value,
                  nama_poliklinik: e.label,
                });
              }
            }}
          />
        </Grid>

        {isNull(formData.no_sep) || formData.no_sep === "-" ? (
          <>
            <Grid item sm={4}>
              <InputOptionMaster
                name='tujuan_kunjungan'
                label='TUJUAN KUNJUNGAN'
                id='tujuan_kunjungan'
                value={formData.tujuan_kunjungan}
                onChange={handleChange("tujuan_kunjungan")}
                data={PILIH_TUJUAN_KUNJUNGAN}
                placeholder=''
              />
            </Grid>
          </>
        ) : (
          <> </>
        )}

        <AssesmentPelayananRawatJalan
          handleChange={handleChange}
          formData={formData}
          type={type}
        />

        {formData.tujuan_kunjungan === TUJUAN_KUNJUNGAN_KONSUL && (
          <>
            <Grid item xs={4}>
              <InputTextMaster
                name='nokontrol'
                label='NO KONTROL'
                id='nokontrol'
                readOnly={true}
                disabled={true}
                placeholder='No Kontrol'
                value={formData.nokontrol}
                onChange={handleChange("nokontrol")}
              />
            </Grid>
          </>
        )}

        {formData.tujuan_kunjungan === TUJUAN_KUNJUNGAN_PROSEDUR && (
          <>
            <PilihFlagProcedure
              handleChange={handleChange}
              formData={formData}
            />
            <PilihKodePenunjang
              handleChange={handleChange}
              formData={formData}
            />
          </>
        )}
      </>
    );
  } else {
    return <></>;
  }
};
